import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ResultsService } from '@ca/core/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultFeedbackModalComponent } from 'src/app/shared/components/send-result-feedback-button/result-feedback-modal/result-feedback-modal.component';

@Component({
    selector: 'ca-send-result-feedback-button',
    templateUrl: './send-result-feedback-button.component.html',
    styleUrls: ['./send-result-feedback-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SendResultFeedbackButtonComponent {
    @Input() workflowResultId: string;

    constructor(
        private modalService: NgbModal,
        private resultsService: ResultsService,
    ) {}

    openFeedbackModal(): void {
        const modal = this.modalService.open(ResultFeedbackModalComponent, { size: 'lg', centered: true });
        modal.componentInstance.resultId = this.workflowResultId;
        modal.componentInstance.shareLinkPrefix = this.resultsService.getResultShareLinkPrefix();
    }
}
